.modal-review-item-content {
  max-height: 345px;
  overflow-y: auto;
}

@media screen and (max-width: 1050px) {
  .ugc-review-dt-all-images-detail-modal,
  .ugc-review-dt-image-modal {
    .modal-review-item-content {
      max-height: 250px;
    }
  }
}

.modal-review-item-opration {
  padding: 8px 0;
  border-top: 1px solid var(--gray-300);
}
